







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import User from "@/models/user/User";
import ReportList from "@/components/report/ReportList.vue";

@Component({
	components: {ReportList, AsiContentContainer}
})
export default class UserTabReports extends Vue {

	@Prop({type: Object, required: true})
	public user!: User;

}
